import * as Config from '../../../config';
import React, { useEffect } from 'react';
import './Faq.css';

import Content from '../common/Content';

function Faq() {
  useEffect(() => {
    document.getElementById(`LFAQ`).scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, [])

  return (
    <Content name={`FAQ`}>
      <div id={`LFAQ`} className={`flexColumn faq`}>
        <div className={`faq-block`}>
          <div className={`faq-title type-title`}>Which browsers are supported?</div>
          <div className={`faq-description type-regular type-secondary`}>
            To achieve the best performance, that is low latency audio and MIDI, we recommended that you use Google Chrome and Microsoft Edge (Chromium) to run the {Config.capAppName()} DJ App.
          </div>
        </div>
        <div className={`faq-block`}>
          <div className={`faq-title type-title`}>What is the minimum computer specification to run {Config.capAppName()} DJ?</div>
          <div className={`faq-description type-regular type-secondary`}>
            {Config.capAppName()} DJ is OS independent and it is designed to run on low-end computers. So if your computer can install and run Google Chrome, you are good to go.
            <p>For a smooth experience we recommend the following:</p>
            <ul>
              <li>Processor: Intel i3</li>
              <li>RAM: 8GB</li>
              <li>Disk Space: 5GB Free Space</li>
            </ul>
            <p>However the minimum requirement, we recommend the following:</p>
            <ul>
              <li>Processor: 2Ghz Dual Core</li>
              <li>RAM: 4GB</li>
              <li>Disk Space: 2GB Free Space</li>
            </ul>
          </div>
        </div>
        <div className={`faq-block`}>
          <div className={`faq-title type-title`}>Performance tips</div>
          <div className={`faq-description type-regular type-secondary`}>
            For the best performance, we recommend keeping the number of Chrome Tabs to a minimum.
            <p>If you are experiencing loading issues please clear your browser cache and refresh the page.</p>
          </div>
        </div>
        <div className={`faq-block`}>
          <div className={`faq-title type-title`}>Which DJ hardware is supported by {Config.capAppName()} DJ?</div>
          <div className={`faq-description type-regular type-secondary`}>
          Please note that MIDI compatibility is currently undergoing development. Although the application is fully MIDI mappable and compatible with any MIDI device, some controllers may require manual mapping. Any modifications to the MIDI settings will be saved to your profile.
          <p>You can access this feature through MIDI in the Settings. Last updated: May, 2024.</p>
          </div>
          <div className={`faq-description type-regular type-secondary`}>
            <table style={{border: `1px solid`, marginBottom: 20}}>
              <thead>
                <tr style={{borderBottom: `1px solid`}}>
                  <th style={{width: 200, padding: 5}}>Manufacture</th>
                  <th style={{width: 350, padding: 5, borderLeft: `1px solid`}}>Model</th>
                </tr>
              </thead>
              <tbody>

                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Allen&Heath</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    XONE K2<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>American Audio</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    VMS2<br/>
                    VMS4<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Behringer</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    BCD2000<br/>
                    BCD3000<br/>
                    CMD MICRO<br/>
                    CMD STUDIO 2A<br/>
                    CMD STUDIO 4A<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Denon DJ</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    MC3000<br/>
                    MC4000<br/>
                    MC6000<br/>
                    MC6000 MK2<br/>
                    MCX8000<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>DJ-Tech</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    I-MIX<br/>
                    KONTROL ONE<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Faderfox</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    DJ44<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Gemini</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    FIRSTMIX<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Hercules</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    CONSOLE 4-MX<br/>
                    CONSOLE 4SET<br/>
                    CONSOLE MAC EDITION<br/>
                    CONSOLE MK2<br/>
                    CONSOLE MK4<br/>
                    CONSOLE RMX 2<br/>
                    CONTROL AIR<br/>
                    CONTROL INPULSE 300<br/>
                    CONTROL INPULSE 500<br/>
                    CONTROL MP3<br/>
                    CONTROL MP3 E2<br/>
                    CONTROL STEEL<br/>
                    CONTROL WAVE<br/>
                    CONTROL COMPACT<br/>
                    CONTROL INPULSE 200<br/>
                    CONTROL INSTINCT<br/>
                    CONTROL INSTINCT P8<br/>
                    CONTROL JOGVISION<br/>
                    CONTROL MP3 LE<br/>
                    CONTROL STARLIGHT<br/>
                    P32 DJ<br/>
                    UNIVERSAL DJ<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Ion</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                   DISCOVER DJ<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Kaoss DJ</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                   CONTROL<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Kontrol DJ</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                   KDJ500<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>M-Audio</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                   X-PONENT<br/>
                   X-SESSION PRO<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>MixVibes</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    U-MIX CONTROL 2<br/>
                    U-MIX CONTROL PRO 2<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Next Beat</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    LX1<br/>
                    SX1<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Novation</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    LAUNCHPAD MINI<br/>
                    LAUNCHPAD MK2<br/>
                    TWITCH<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Numark</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    4TRAK<br/>
                    DJ2GO<br/>
                    DJ2GO2<br/>
                    IDJ LIVE II<br/>
                    IDJ PRO<br/>
                    IDJ3<br/>
                    MIXDECK<br/>
                    MIXDECK QUAD<br/>
                    MIXTRACK<br/>
                    MIXTRACK 3<br/>
                    MIXTRACK PLATINUM<br/>
                    MIXTRACK PLATINUM FX<br/>
                    MIXTRACK PRO 2<br/>
                    MIXTRACK PRO 3<br/>
                    MIXTRACK PRO<br/>
                    N4<br/>
                    NS6<br/>
                    NS7<br/>
                    NV MKII<br/>
                    PARTY MIX<br/>
                    PARTY MIX MKII<br/>
                    TOTAL CONTROL<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Pioneer DJ</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    CDJ-2000<br/>
                    CDJ-3000<br/>
                    DDJ-1000<br/>
                    DDJ-200<br/>
                    DDJ-400<br/>
                    DDJ-800<br/>
                    DDJ-ERGO<br/>
                    DDJ-FLX4<br/>
                    DDJ-FLX6<br/>
                    DDJ-RB<br/>
                    DDJ-RX<br/>
                    DDJ-RZ<br/>
                    DDJ-RZX<br/>
                    DDJ-S1<br/>
                    DDJ-SB<br/>
                    DDJ-SB2<br/>
                    DDJ-SB3<br/>
                    DDJ-SR<br/>
                    DDJ-SR2<br/>
                    DDJ-SX<br/>
                    DDJ-SX2<br/>
                    DDJ-SZ<br/>
                    DDJ-SZ2<br/>
                    DDJ-WEGO<br/>
                    DDJ-WEGO2<br/>
                    DDJ-WEGO3<br/>
                    DDJ-WEGO4<br/>
                    XDJ-R1<br/>
                    XDJ-RX<br/>  
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Reloop</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    BEATMIX 2<br/>
                    BEATMIX 2 MK2<br/>
                    BEATMIX<br/>
                    BEATMIX 4<br/>
                    BEATMIX 4 MK2<br/>
                    BEATPAD<br/>
                    BUDDY<br/>
                    DIGITAL JOCKEY 2<br/>
                    JOCKEY 3 ME<br/>
                    MIXON 4<br/>
                    MIXTOUR<br/>
                    NEON<br/>
                    READY<br/>
                    RP8000<br/>
                    TERMINAL MIX 2<br/>
                    TERMINAL MIX 4<br/>
                    TERMINAL MIX 8<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Roland</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    DJ-202<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Traktor</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    KONTROL S2<br/>
                    KONTROL S2 MK2<br/>
                    KONTROL S2 MK3<br/>
                    KONTROL S3<br/>
                    KONTROL S4<br/>
                    KONTROL S4 MK2<br/>
                    KONTROL X1 MK2<br/>
                    KONTROL Z1<br/>
                    KONTROL Z2<br/>
                  </td>
                </tr>
                <tr style={{borderBottom: `1px solid`}}>
                  <td style={{padding: 5}}>Vestax</td>
                  <td style={{padding: 5, borderLeft: `1px solid`}}>
                    SPIN<br/>
                    TYPHOON<br/>
                    VCI-100<br/>
                    VCI-100MKII<br/>
                    VCI-300<br/>
                    VCI-380<br/>
                    VCI-400<br/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Content>
  )
}

export default Faq;
